import Preload from './preload';
import ContentContainer from './content-container';
import Card from '../card';
import { findBlockByName } from '../../helpers/blockHelpers';
import { getCategory, getText } from '../../pages/experience';
import { getFactsText, getListprice } from '../../pages/accommodations';
import classNames from 'classnames';

const RelatedContent = ({
    isLoading,
    pageIds,
    pages,
    categories,
    sliderContainerRef,
    navigationProps,
    nextPage,
    prevPage,
    isEdit,
    isWideFirst,
    isSliderOnSmall
}) => {
    if (isLoading) {
        return (
            <ContentContainer>
                <Preload 
                    pageIds={pageIds} 
                    isWideFirst={isWideFirst} 
                    isSliderOnSmall={isSliderOnSmall} />
            </ContentContainer>
        );
    }

    const getImages = postItem => {
        if (!postItem || !postItem.blocks) {
            return null;
        }
    
        //Find first occurance of image gallery block
        const imageGallery = findBlockByName('dalslandskanal-custom-blocks/image-gallery', postItem.blocks);
        const imageCarousel = findBlockByName('dalslandskanal-custom-blocks/image-slider', postItem.blocks);
        
        //Has featured media
        if (postItem._embedded && postItem._embedded['wp:featuredmedia'] && postItem._embedded['wp:featuredmedia'].length > 0) {
            return [{
                src: postItem._embedded['wp:featuredmedia'][0].media_details.sizes.medium ? postItem._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url :  postItem._embedded['wp:featuredmedia'][0].source_url,
                alt: '',
                title: ''
            }]
        }


        if (imageGallery) {
            return imageGallery.attrs.images;
        }
    
        if(imageCarousel) {
            return imageCarousel.attrs.images;
        }
    
        return null;
    }

    const getFirstText = postItem => {
        if (!postItem || !postItem.blocks) {
            return null;
        }
    
        if (postItem.type === 'accommodation') {
            return <span className="card__facts">{getFactsText(postItem)}</span>;
        }

        return <span className="card__category">{getCategory(postItem, categories)}</span>;
       
    };

    const getAltText = (postItem, longText = false) => {

        if (!postItem || !postItem.blocks) {
            return null;
        }
    
        if (postItem.type === 'accommodation') {
            return <span className="card__altfacts">{getListprice(postItem)}</span>;
        }

        return <span className="card__text" dangerouslySetInnerHTML={ { __html: getText(postItem, longText ? 220 : 100) } }></span>;
    };

    return (
        <ContentContainer>
            <div className="related-content__container">
                {navigationProps && navigationProps.hasNavigation &&
                    <div className="related-content__navigation">
                        <button 
                            className="related-content__navigation-button related-content__navigation-button--prev"
                            type="button" 
                            onClick={prevPage}
                            disabled={navigationProps.prevDisabled}><span>Föregående</span></button>
                        <button 
                            className="related-content__navigation-button related-content__navigation-button--next"
                            type="button" 
                            onClick={nextPage}
                            disabled={navigationProps.nextDisabled}><span>Nästa</span></button>
                    </div>
                }
                <div className={classNames({
                    'related-content__pages-container': true,
                    'related-content__pages-container--is-slider': isSliderOnSmall
                })}>
                    <ul className={classNames({
                        'related-content__pages': true,
                        'related-content__pages--is-wide': isWideFirst
                    })} ref={sliderContainerRef}>
                        {pages.map((page, index) => {
                            return (
                                <li key={`${page.id}${index}`} className={classNames({
                                    'related-content__page': true,
                                    'related-content__page--accommodation': page.type === 'accommodation',
                                    'related-content__page--is-wide': index === 0 && isWideFirst
                                })}>
                                    <Card key={page.id} id={page.id} hoverHandler={() => {}} url={isEdit ? false : page.link} title={page.title && page.title.rendered} images={getImages(page)} facts={getFirstText(page)} altFacts={getAltText(page, index === 0 && isWideFirst)} useMediumImages={true} lazyLoadAttribute={{loading: 'lazy'}} />
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </ContentContainer>
    );
};

export default RelatedContent;